import { AdvanceFieldsForm } from '@eventr/common-storybook'
import { withTierPermission } from '../HOC/withTierPermission'

export const PremiumAdvanceFields = withTierPermission(AdvanceFieldsForm, {
    requiredTier: ['enterprise'],
})
